import { useState, useCallback } from 'react';

export function usePostcodeSearch() {
    const [nearbyAreas, setNearbyAreas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isValid, setIsValid] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    // Find areas by Postcode + Radius
    const findNearbyAreas = useCallback(async (postcode, radiusValue = 5) => {
        const cleanPostcode = postcode?.replace(/\s/g, '');
        if (!cleanPostcode || cleanPostcode.length < 5) {
            setIsValid(null); // Reset when too short
            setLatitude(null);
            setLongitude(null);
            return;
        }

        setIsLoading(true);
        try {
            const geoRes = await fetch(`https://api.postcodes.io/postcodes/${encodeURIComponent(cleanPostcode)}`);
            const geoData = await geoRes.json();
            
            // FIX: If status is not 200, it is NOT valid
            if (geoData.status !== 200) {
                setIsValid(false);
                setNearbyAreas([]);
                setLatitude(null);
                setLongitude(null);
                console.warn("Postcode not found or incomplete.");
                setIsLoading(false);
                return;
            }

            // Check POSTCODE IS VALID
            setIsValid(true);

            const { latitude: lat, longitude: lon } = geoData.result;
            setLatitude(lat);
            setLongitude(lon);

            const radiusInMeters = Math.min(Math.round(radiusValue * 1609.34), 25000); 

            const areasRes = await fetch(`https://api.postcodes.io/outcodes?lat=${lat}&lon=${lon}&radius=${radiusInMeters}&limit=100`);
            const areasData = await areasRes.json();
            
            if (areasData.result && areasData.result.length > 0) {
                const extracted = areasData.result.flatMap(p => [
                    ...(Array.isArray(p.admin_district) ? p.admin_district : []), 
                    ...(Array.isArray(p.parish) ? p.parish : []) 
                ]).filter(name => 
                    name && typeof name === 'string' && !name.toLowerCase().includes("unparished")
                );

                const uniqueAreas = [...new Set(extracted)].sort();
                setNearbyAreas(uniqueAreas);
            } else {
                setNearbyAreas([]);
            }
        } catch (err) {
            setIsValid(false);
            setLatitude(null);
            setLongitude(null);
            console.error("Lookup error:", err);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Returns latitude and longitude along with your existing values
    return { nearbyAreas, isLoading, isValid, findNearbyAreas, latitude, longitude };
}